import React from "react";

import { connect } from "react-redux";
import { DragAndDropContext } from "../../../../context/DragAndDropContext";
import * as actionTypes from "../../../../store/Actions/actions";
import * as UTILS from "../../../../utils/Utils";
import cloneDeep from "lodash.clonedeep";
import shortid from "shortid";
import "bootstrap/dist/css/bootstrap.min.css";
import BlockTitle from "./BlockTitle";
import { Container, Draggable } from "react-smooth-dnd";
import Rename from "../../../../assets/images/edit-noBorder.svg";
import "./Blocks.scss";
// import ReactTooltip from 'react-tooltip';
import "bootstrap/dist/css/bootstrap.min.css";
import TopBottomMove from "../../../../assets/images/topBottomMove.svg";
import CloseCross from "../../../../assets/images/closeCrossBlack.svg";
import DragMark from "../../../../assets/images/dragMark.png";
import noImage from "../../../../assets/images/noimage.png";
import "../../../Controls/ReloadButton.scss";
import { track } from "@amplitude/analytics-browser";
import Axios from "../../../../axios";

let newLayout = null;
class BlocksThumbDND extends React.Component {
  constructor(props) {
    super(props);
    this.scrollerRef = React.createRef();
    this.state = {
      dragToCanvas: null,
      layout: null,
      id: this.props.ID,
      addedBlock: false,
      blocks: [],
      selectedBlock: "",
      selectedBlockData: "custom",
      blockToPush: null,
      activeTab: "0",
      place: "right",
      type: "dark",
      effect: "float",
      condition: false,
      templateTitleEnable: null,
      templateTitle: null,
      brokenImages: [],
      thumbnailToShow: null,
      selectedCategory: "hero/header",
      page: 1,
      sameCategory: true,
      display: false,
      loading: false,
      animate: true,
      more: true,
      dimensions: {},
      blockData: null,
    };
    this.pushBlockToCanvas = this.pushBlockToCanvas.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onImgLoad = this.onImgLoad.bind(this);
  }
  static contextType = DragAndDropContext;
  componentDidMount = () => {
    this.getBlocks();
    this.setState({
      selectedBlock: "",
    });
    // this.refs.blockScroll.addEventListener("scroll", () => {

    // if ((this.refs.blockScroll.scrollTop + this.refs.blockScroll.clientHeight >= this.refs.blockScroll.scrollHeight - 0.5) && this.state.sameCategory && !this.state.loading) {

    // this.getBlocks();
    // }
    // })
    document.addEventListener("keypress", this.onKeyPress, false);
    track("Block Option Selected", {
      entryPoint: "Navigation Bar",
    });
  };

  handleScroll = async (evt) => {
    const scroller = this.scrollerRef.current;

    if (
      scroller.scrollTop + scroller.clientHeight >=
        scroller.scrollHeight - 30 &&
      this.state.sameCategory &&
      !this.state.loading &&
      this.state.more
    ) {
      this.getBlocks();
    }
  };

  componentWillUnmount = () => {
    this.setState({
      selectedBlock: "",
      blocks: [],
      brokenImages: [],
      display: false,
    });
    document.removeEventListener("keypress", this.onKeyPress, false);
  };
  onKeyPress(event) {
    if (event.code === "KeyS") {
      this.setState((prevState) => ({
        display: !prevState.display,
      }));
      // this.setState({
      //   display: !this.state.display
      // })
    }
  }
  onDragStart = async (event, payload) => {
    let requestData = await Axios.BlockService.GET_BLOCK_DATA(
      payload,
      this.props.userID,
      this.props.sessionID
    );
    let { data } = await requestData.data;
    data = UTILS.PushWithID(JSON.parse(data.data));
    this.context.onDrag(
      event,
      Object({ id: "block", data: data }),
      Object({
        data: "block",
        id: "block",
      })
    );

    // this.setState({
    //   ...this.state,
    //   blockData: data,
    // });
  };
  DragEnd = () => {
    this.context.onDragEnd();
  };
  getBlocks = () => {
    // this.setState({
    //   loading: true,
    // })
    this.setState((prevState) => ({
      loading: true,
      animate: prevState.page === 1 ? true : false,
    }));

    Axios.BlockService.GET_BLOCK_THUMBNAILS(
      this.props.userID,
      this.props.sessionID,
      `B&c=${this.state.selectedCategory}&page=${this.state.page}`
    )
      .then((response) => {
        if (response.status == 200) {
          let data = response.data.data[this.state.selectedCategory]
            ? response.data.data[this.state.selectedCategory]
            : [];

          this.setState({
            blocks: [...this.state.blocks, ...data],
            loading: false,
            page: this.state.page + 1,
            sameCategory: true,
            more: data.length > 0 ? true : false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          reloadBlock: true,
          somethingWentWrong: true,
        });
      });
  };
  restoreCustom = () => {
    let reorder = { data: [] };
    Object.keys(this.state.blocks).map((item, index) => {
      if (item == "custom") {
        return {
          [item]: this.state.blocks[item].map((i, ind) => {
            let newI = {};
            newI.id = i.template_id;
            reorder.data = [...reorder.data, newI];
            return newI;
          }),
        };
      }
      return { [item]: this.state.blocks[item] };
    });

    const data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      tids: JSON.stringify(reorder),
      t: "B",
    };
    reorder &&
      Axios.BlockService.POST_BLOCKS_REORDER(data).then((response) => {
        if (response.status == "200") {
        }
        if (response.status == "error") {
        }
      });
    // .catch(error => {

    // });
  };
  selectedBlock = (blockData) => {
    // le.log("SELECTED BLOCK")
    this.setState(
      {
        selectedBlock: blockData,
      },
      () => {
        let layout =
          this.state.selectedBlock &&
          this.state.selectedBlock.data &&
          JSON.parse(this.state.selectedBlock.data).block;

        // let textValue = this.state.textContent;

        const newLayout = UTILS.ConvertTextContent(
          layout,

          (item) => {
            item.text = UTILS.ConvTextChar(item.text);
          },
          (colItem) => {
            colItem.text = UTILS.ConvTextChar(colItem.text);
          },
          (colItemNested) => {
            colItemNested.text = UTILS.ConvTextChar(colItemNested.text);
          }
        );

        this.setState({
          blockToPush: newLayout,
        });
      }
    );
  };
  renameTitle = (indexToStateUpdate, isDefault, category) => {
    this.setState({
      renameClicked: true,
    });
    const data = {
      u: this.props.userID,
      sn: this.props.sessionID,
      nm: this.state.templateTitle,
      id: this.state.templateTitleEnable,
      isDef: isDefault,
      // templateTitleEnable
      // templateTitle
    };
    Axios.BlockService.POST_BLOCKS_UPDATE_NAME(data).then((response) => {
      if (response.status == 200) {
        const blocks = cloneDeep(this.state.blocks);

        // blocks[category].map((item, index) => {
        blocks.map((item, index) => {
          if (index == indexToStateUpdate) {
            item.template_name = this.state.templateTitle;
            return item;
          } else {
            return item;
          }
        });
        const self = this;
        this.setState(
          {
            blocks,
          },
          () => {
            this.setState({
              blocks: this.state.blocks,
            });
            setTimeout(function () {
              self.setState({
                templateTitle: null,
                renameClicked: false,
                templateTitleEnable: null,
              });
            }, 500);
          }
        );
      }
      if (response.status == "error") {
      }
    });
    // .catch(error => {

    // });
  };
  handleChange = (evt) => {
    this.setState({ templateTitle: evt.target.value });
  };
  pushBlockToCanvas = () => {
    newLayout = cloneDeep(this.props.layout);
    let getBlockItem = null;
    let dataComplete = false;
    const data = this.state.blockToPush;
    const newData = UTILS.IDFilter(
      data,
      (item) => {
        item.id = "F" + shortid();
      },
      (colItem) => {
        colItem.id = "F" + shortid();
      },
      (colItemNested) => {
        colItemNested.id = "F" + shortid();
      }
    );
    let mergedData = [];
    if (this.props.ID) {
      const indexVal = newLayout.findIndex((item) => item.id === this.props.ID);
      newLayout.splice(indexVal + 1, 0, ...newData);
      mergedData = [...newLayout];
    } else {
      mergedData = [...newLayout, ...newData];
    }
    this.setState(
      {
        addedBlock: true,
      },
      () => {
        setTimeout(
          function () {
            this.setState({ addedBlock: false });
          }.bind(this),
          2000
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, mergedData);
    this.props.closeBlocks();
  };
  getLayoutList = () => {
    const selectedLayout = this.props.layoutList.map((item, ind) => {});
  };
  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      nextState.blocks !== this.state.blocks ||
      nextState.selectedBlockData !== this.state.selectedBlockData ||
      nextState.brokenImages !== this.state.brokenImages ||
      nextState.templateTitleEnable !== this.state.templateTitleEnable ||
      nextState.templateTitle !== this.state.templateTitle ||
      nextState.renameClicked !== this.state.renameClicked ||
      nextState.templateTitle !== this.state.templateTitle ||
      nextState.renameClicked !== this.state.renameClicked ||
      nextState.dragToCanvas !== this.state.dragToCanvas ||
      nextState.thumbnailToShow !== this.state.thumbnailToShow ||
      nextState.display !== this.state.display ||
      nextState.loading !== this.state.loading ||
      nextState.animate !== this.state.animate ||
      nextState.more !== this.state.more ||
      nextState.dimensions !== this.state.dimensions
    ) {
      return true;
    } else {
      return false;
    }
  };
  onImgLoad({ target: img }) {
    const { offsetHeight, offsetWidth } = img;

    this.setState({
      dimensions: {
        height: offsetHeight,
        width: offsetWidth,
      },
    });
  }

  render() {
    const { place, type, effect, loading, sameCategory, animate } = this.state;
    const { width, height } = this.state.dimensions;
    return (
      <div className="sideblocksPanel" ref={this.props.refInput}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            paddingLeft: "12px",
            paddingTop: "12px",
          }}
        >
          <div className="selectWrapper">
            <select
              onChange={(e) => {
                track("Blocks Category Selected", {
                  categoryName: e.target.value,
                });
                this.setState(
                  {
                    blocks: [],
                    selectedCategory: e.target.value,
                    page: 1,
                    sameCategory: false,
                  },
                  () => {
                    this.getBlocks();
                  }
                );
              }}
            >
              <option value="hero/header">Hero / Header (24)</option>
              <option value="featured content">Featured Content (24)</option>
              <option value="video">Video (31)</option>
              <option value="cta/informative">CTA / Informative (135)</option>
              <option value="lists">Lists (12)</option>
              <option value="footer">Footer (7)</option>
              <option value="custom">Custom</option>
            </select>
          </div>
          <button
            onClick={this.props.closeBlocksSidebar}
            style={{
              border: "0",
              height: "31px",
              width: "30px",
              background: "#eee",
            }}
          >
            <img src={CloseCross} />
          </button>
        </div>
        {this.state.thumbnailToShow !== null && (
          <div className="thumbnailDisplay">
            <span
              onClick={() => {
                this.setState({
                  thumbnailToShow: null,
                });
              }}
              className="close"
            ></span>
            {/* <img className="thumbnail" src={this.state.thumbnailToShow} /> */}
            <img
              onLoad={this.onImgLoad}
              className="thumbnail"
              src={this.state.thumbnailToShow}
            />
          </div>
        )}
        {/* {!loading
          ? (
            
          )
          : <div className="pleaseWaitBlock">Please wait...</div>
        } */}

        {/* <div className={"blocksThumbWrapper" + (this.state.dragToCanvas ? " dragToCanvas" : ' ') + (!loading && animate ? ' animate__animated animate__fadeIn' : '')} ref="blockScroll" > */}
        <div
          className={
            "blocksThumbWrapper" +
            (this.state.dragToCanvas ? " dragToCanvas" : " ") +
            (!loading && animate ? " animate__animated animate__fadeIn" : "")
          }
          ref={this.scrollerRef}
          onScroll={this.handleScroll}
        >
          <Container dragHandleSelector=".form-drag-handle">
            {this.state.blocks.map((item, index) => {
              return (
                <Draggable key={index}>
                  <div className="blocks-master-wrapper">
                    <div
                      onError={(e) => {
                        this.setState({
                          brokenImages: [
                            ...this.state.brokenImages,
                            item.template_id,
                          ],
                        });
                      }}
                      className={
                        "blocksThumbnailIMG item " +
                        (this.state.brokenImages &&
                        this.state.brokenImages.filter((it, ind) => {
                          return it == item.template_id;
                        }).length > 0
                          ? " invalid "
                          : " ")
                      }
                    >
                      <span
                        className="clickToShowBTN"
                        onClick={() => {
                          let localThumb =
                            this.state.brokenImages &&
                            this.state.brokenImages.filter((it, ind) => {
                              return it == item.template_id;
                            }).length > 0
                              ? "https://flimp3.s3.amazonaws.com/files/noimage.png"
                              : item.thumb;
                          this.setState({
                            thumbnailToShow: localThumb,
                          });
                        }}
                      >
                        <i className="far fa-eye" />
                      </span>

                      <img
                        onError={(e) => {
                          e.target.src = noImage;
                        }}
                        className={
                          "blockThumbnail " +
                          (this.state.brokenImages.filter((it, ind) => {
                            return it == item.template_id;
                          }).length > 0
                            ? " invalid "
                            : " ")
                        }
                        // style={{ width: '90%', height: '85px', objectFit: 'contain' }}
                        onDragStart={(event) => {
                          this.onDragStart(event, item.template_id);
                        }}
                        onDragEnd={(e) => {
                          this.DragEnd(e);
                        }}
                        src={
                          this.state.brokenImages.filter((it, ind) => {
                            return it == item.template_id;
                          }).length > 0
                            ? "https://flimp3.s3.amazonaws.com/files/noimage.png"
                            : item.thumb
                        }
                      />

                      {this.state.templateTitleEnable == item.template_id ? (
                        <div className="update-title-wrapper">
                          <div className="update-title">
                            <input
                              style={{
                                width: this.state.templateTitle
                                  ? this.state.templateTitle.length * 10 + 30
                                  : 80 + "px",
                              }}
                              defaultValue={this.state.templateTitle}
                              onChange={this.handleChange}
                              type="text"
                            />
                            <button
                              onClick={() => {
                                this.renameTitle(
                                  index,
                                  item.is_default,
                                  this.state.selectedBlockData
                                );
                              }}
                              className="save-title"
                            >
                              {this.state.renameClicked ? (
                                <div className="loading"></div>
                              ) : (
                                <i className="fas fa-check"></i>
                              )}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <p className="title-block">
                          {item.template_name == null && (
                            <small
                              className="title-template noTitle"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  templateTitleEnable: item.template_id,
                                });
                              }}
                            >
                              Click here to add title.
                            </small>
                          )}
                          {item.template_name !== null && (
                            <small
                              className="title-template titleMain"
                              style={{ fontWeight: "500", color: "#0c3254" }}
                            >
                              {item.template_name}
                              {(this.state.selectedCategory === "custom" ||
                                (this.state.selectedCategory !== "custom" &&
                                  this.state.display)) && (
                                <button className="icoWrap">
                                  <img
                                    onClick={() => {
                                      this.setState({
                                        templateTitleEnable: item.template_id,
                                        templateTitle: item.template_name,
                                      });
                                    }}
                                    src={Rename}
                                  />
                                </button>
                              )}
                            </small>
                          )}
                        </p>
                      )}
                      {(this.state.selectedCategory === "custom" ||
                        (this.state.selectedCategory !== "custom" &&
                          this.state.display)) && (
                        <BlockTitle
                          sessionID={this.props.sessionID}
                          userID={this.props.userID}
                          template_id={item.template_id}
                          is_default={item.is_default}
                          updateBlockState={(index) => {
                            const updatedBlock = this.state.blocks.filter(
                              (val, valIndex) => {
                                return index !== valIndex;
                              }
                            );
                            this.setState({
                              blocks: [...updatedBlock],
                            });
                          }}
                          index={index}
                        />
                      )}
                    </div>
                  </div>
                </Draggable>
              );
            })}
            {loading && <div className="pleaseWaitBlock">Please wait...</div>}
          </Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    layout: state.present.layout,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
    layoutList: state.present.layoutList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BlocksThumbDND);
